import { NgIf, AsyncPipe } from '@angular/common'
import { Component, ElementRef } from '@angular/core'
import { RouterLink } from '@angular/router'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import {
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  TranslatePipe,
  UrlPipe
} from '@spartacus/core'
import {
  LaunchDialogService,
  FocusDirective,
  IconComponent,
  GlobalMessageComponent
} from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { filter, map, switchMap } from 'rxjs/operators'
import { EbSpinnerComponent } from '../../../../components/spinner/eb-spinner.component'
import { EbAddedToCartDialogComponent } from '../../../cart/components/added-to-cart-dialog/eb-added-to-cart-dialog.component'
import { EbCartItemComponent } from '../../../cart/components/cart-item/eb-cart-item.component'
import { EbCartItemHeaderComponent } from '../../../cart/components/cart-item-header/eb-cart-item-header.component'

@Component({
  selector: 'eb-added-favorites-to-cart',
  templateUrl: './eb-added-favorites-to-cart.component.html',
  styleUrls: ['./eb-added-favorites-to-cart.component.scss'],
  imports: [
    FocusDirective,
    NgIf,
    IconComponent,
    GlobalMessageComponent,
    EbCartItemHeaderComponent,
    EbCartItemComponent,
    RouterLink,
    EbSpinnerComponent,
    AsyncPipe,
    TranslatePipe,
    UrlPipe
  ]
})
export class EbAddedFavoritesToCartComponent extends EbAddedToCartDialogComponent {
  addedEntries: number
  entriesTriedToAdd: number
  addedEntriesWereMerged$: Observable<boolean>

  constructor(
    activeCartFacade: ActiveCartFacade,
    launchDialogService: LaunchDialogService,
    routingService: RoutingService,
    el: ElementRef,
    protected globalMessageService: GlobalMessageService
  ) {
    super(activeCartFacade, launchDialogService, routingService, el)
  }

  ngOnInit() {
    if (this.entriesTriedToAdd !== this.addedEntries) {
      this.globalMessageService.add(
        {
          key: 'addFavoritesToCart.entriesWithoutPrice',
          params: { count: this.entriesTriedToAdd - this.addedEntries }
        },
        GlobalMessageType.MSG_TYPE_WARNING,
        Number.MAX_VALUE
      )
    }
    this.addedEntriesWereMerged$ = this.loaded$.pipe(
      filter(loaded => loaded),
      switchMap(() => this.activeCartFacade.getEntries()),
      map(entries => entries.length === this.entriesTriedToAdd)
    )
    super.ngOnInit()
  }
}
